import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc PersonalIdWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { PersonalIdWidgetService } from 'services/personalIdWidget';
 *
 * // create service instance and send/cancel request
 * const personalIdWidgetService = new PersonalIdWidgetService();
 * const result = await personalIdWidgetService.fetchData( '<user-id>' ); // fetch data
 * personalIdWidgetService.cancel(); // cancel an active request
 */
export class PersonalIdWidgetService extends HttpService {

    // submit form data
    async submitFormData( { url = {}, data = {} } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data', {} )
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
